import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import da from './locales/da.json';
import en from './locales/en.json';

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      da: { translation: da },
      en: { translation: en },
    },
    // Danish-first: this is the Danish register. English is supported
    // for the rare external-lender integrator who's not Danish-native
    // and selectable via the header toggle (see LanguageToggle.tsx).
    fallbackLng: 'da',
    supportedLngs: ['da', 'en'],
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'lexta-lang',
      caches: ['localStorage'],
    },
  });

export default i18n;
